import { updateCheckPermCount } from '../actions/permissionCheckerInternalActions';
import getPermissionCheckerInfo from '../selectors/getPermissionCheckerInfo';
import { mutator } from 'satcheljs';

mutator(updateCheckPermCount, actionMessage => {
    let permissionCheckerInfo = getPermissionCheckerInfo(actionMessage.composeId);
    permissionCheckerInfo.pendingCheckPermCount =
        permissionCheckerInfo.pendingCheckPermCount + actionMessage.offset;
});
